import _ from 'lodash';

export function isEqual<T>(left: T, right: any) {
    return _.isEqual(left, right);
}
